import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VpInfoMenu } from '../../components';
import { copyToClipboard } from '../../../utils/copyToClipboard';
import { useVpSnackbar } from '../../hooks';
import { useForceDownload } from '../../../hooks';
import { showSocialShareModal } from '../../../redux/modules/share';
import { useMediaTableContext } from '../../../hooks/contexts';
import { getDownloadOriginalVideoEnabled } from '../../../redux/modules/auth';

const getMenuItems = (allowDownload) => [
  {
    id: 'copy',
    label: 'Copy Link',
    icon: 'Copy'
  },
  {
    id: 'share',
    label: 'Share',
    icon: 'Share2'
  },
  {
    id: 'download',
    label: 'Download Media',
    icon: 'DownloadCloud'
  },
  {
    id: 'download_raw',
    label: 'Download Unprocessed Media',
    icon: 'Download',
    conditionalProps: {
      condition: !allowDownload
    }
  },
  {
    id: 'delete',
    label: 'Delete',
    icon: 'Trash2',
    variant: 'error'
  }
];

export const VpMediaInfoMenu = ({ media, _showSocialShareModal, downloadOriginalEnabled }) => {
  const id = media?.mediaId || media?.attachmentId;

  const MENU_ITEMS = getMenuItems(downloadOriginalEnabled);

  const { addSnackbarInfo } = useVpSnackbar();
  const { forceDownload, isLoading } = useForceDownload();
  const { setSelectedEntity, setSelectedSubmissionId } = useMediaTableContext();

  const onSelect = (item) => {
    switch (item?.id) {
      case 'copy': {
        copyToClipboard(`${window?.location?.origin}/share/${media?.mediaRawPath}`);
        addSnackbarInfo({ message: 'Copied link to clipboard', title: '' });
        return;
      }
      case 'share': {
        // this is the description of the question, not the description of the video that the user can update
        //   so we want to blank this out so it doesn't show in the youtube description box
        _showSocialShareModal(null, { ...media, description: '' });
        setSelectedSubmissionId(null);
        return;
      }
      case 'download': {
        const mediaUrlSplit = media?.mediaUrl?.split('/');
        const fileName = mediaUrlSplit[mediaUrlSplit.length - 1];
        forceDownload(media?.mediaUrl, fileName);
        return;
      }
      case 'download_raw': {
        const mediaUrlSplit = media?.originalPath?.split('/');
        const fileName = mediaUrlSplit[mediaUrlSplit.length - 1];
        forceDownload(media?.originalPath, fileName);
        return;
      }
      case 'delete': {
        setSelectedEntity(media);
        return;
      }
    }
  };

  return <VpInfoMenu id={id} loading={isLoading} menuItems={MENU_ITEMS} onSelect={onSelect} />;
};

VpMediaInfoMenu.propTypes = {
  _showSocialShareModal: PropTypes.func,
  media: PropTypes.object,
  disableCustomizeThumbnail: PropTypes.bool,
  downloadOriginalEnabled: PropTypes.bool
};

const mapStateToProps = (state) => ({
  downloadOriginalEnabled: getDownloadOriginalVideoEnabled(state)
});
const mapDispatchToProps = {
  _showSocialShareModal: showSocialShareModal
};

export default connect(mapStateToProps, mapDispatchToProps)(VpMediaInfoMenu);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaInfoMenu.jsx